import { render } from "./DemandeInscriptionPage.vue?vue&type=template&id=a7aa5116"
import script from "./DemandeInscriptionPage.vue?vue&type=script&lang=js"
export * from "./DemandeInscriptionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__